import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getUserInfoProfile } from "../services/ApiServices";
import { useDispatch } from "react-redux";
import dummyUserProfile from '../images/dummyUser.svg';

const Header = ({toggleSidebar}) => {

    const userProfile = JSON.parse(window.localStorage.getItem("users"));


    const dispatch = useDispatch()
    const navigate = useNavigate()

    const getUserProfileRediect = async () => {
        navigate('/userProfile')
    }
    const getChangePasswordRediect = async () => {
        navigate('/changePassword')
    }

    useEffect(() => {
        const getUserProfile = async () => {
            try{
                const userData = await getUserInfoProfile()
                if(userData.status === 200) {
                    dispatch({ type: 'USERS_INFO', payload: userData.data?.data})
                }
            } catch(error) {
    
            }
        }
        getUserProfile()
    })


    const logoutHandle = () => {
        window.localStorage.clear();
        window.location.href = "/";
    }


    return(
        <React.Fragment>
            <div className="header-bar">
                <div className="menu-bar">
                <FontAwesomeIcon icon={faBars} onClick={() => toggleSidebar()} />
                </div>

            <Dropdown className="user-profile-border">
                <Dropdown.Toggle id="dropdown-basic" className="user-profile">
                    <img src={ userProfile?.profileImage !== null ? userProfile?.profileImage : dummyUserProfile } alt="Profile" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => getUserProfileRediect()} >Profile</Dropdown.Item>
                    <Dropdown.Item onClick={() => getChangePasswordRediect()} >Change Password</Dropdown.Item>
                    <Dropdown.Item onClick={() => logoutHandle()}>Logout</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
                </div>
        </React.Fragment>
    )
};
export default Header;